// extracted by mini-css-extract-plugin
export default {"label":"InfoTexts_label__f9m3W","value":"InfoTexts_value__wVY5u"};